// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  tierId: __t.u64().primaryKey().name("tier_id"),
  renderAssetId: __t.u64().name("render_asset_id"),
  lod: __t.u8(),
  maxTextureRes: __t.u16().name("max_texture_res"),
  uri: __t.string(),
  sizeBytes: __t.u64().name("size_bytes"),
});
